// Shared by open-position previews and completed trades. Clip older entries at
// the plot edge so long holds remain connected as the chart scrolls.
export function drawTradeConnections(ctx, trades, position, { market, price, index, fraction, first, step, left, right, top, bottom, y, format }) {
  const closed = trades.filter(t => t.market === market && t.end >= first);
  const active = position?.market === market ? { ...position, exit: price, end: index, endFraction: fraction, pnl: position.units * price - position.cost, active: true } : null;
  const visible = active ? [...closed, active] : closed;
  const x = (bar, progress = .5) => left + (bar - first + .2 + progress * .6) * step;
  ctx.save(); ctx.beginPath(); ctx.rect(left, top, right - left, bottom - top); ctx.clip();
  visible.forEach((trade, i) => {
    const fromX = x(trade.index, trade.entryFraction), fromY = y(trade.entry);
    const toX = x(trade.end, trade.endFraction), toY = y(trade.exit);
    const color = trade.pnl > 0 ? '#35ed9b' : trade.pnl < 0 ? '#ff647c' : '#d0dbe2';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.setLineDash(trade.active ? [7, 4] : []);
    ctx.beginPath(); ctx.moveTo(fromX, fromY); ctx.lineTo(toX, toY);
    ctx.strokeStyle = '#08141ee6'; ctx.lineWidth = 8; ctx.stroke();
    ctx.strokeStyle = color; ctx.lineWidth = 3.5; ctx.stroke(); ctx.setLineDash([]);
    for (const [px, py, label] of [[fromX, fromY, 'B'], [toX, toY, trade.active ? '•' : 'S']]) {
      if (px < left || px > right) continue;
      ctx.beginPath(); ctx.arc(px, py, 8, 0, Math.PI * 2);
      ctx.fillStyle = '#0b1c25'; ctx.fill(); ctx.strokeStyle = color; ctx.lineWidth = 2.5; ctx.stroke();
      ctx.fillStyle = color; ctx.font = 'bold 9px system-ui'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(label, px, py);
    }
    // Keep recent results readable without covering every historical candle.
    if (i >= visible.length - 3) {
      const label = `${trade.active ? 'NOW ' : ''}${format(trade.pnl)}`;
      ctx.font = 'bold 11px system-ui'; const width = ctx.measureText(label).width + 14;
      const labelX = Math.max(left + 2, Math.min(toX - width / 2, right - width - 2));
      const labelY = Math.max(top + 2, Math.min(toY - 33 - ((visible.length - 1 - i) % 2) * 19, bottom - 22));
      ctx.fillStyle = '#0b1c25ee'; ctx.fillRect(labelX, labelY, width, 20);
      ctx.strokeStyle = color; ctx.lineWidth = 1; ctx.strokeRect(labelX, labelY, width, 20);
      ctx.fillStyle = color; ctx.textAlign = 'left'; ctx.textBaseline = 'middle'; ctx.fillText(label, labelX + 7, labelY + 10);
    }
  });
  ctx.restore();
}
